'use client';

import Link from 'next/link';

export default function PageError({ reset }: { reset: () => void }) {
  return <div className="study-theme min-h-screen flex items-center justify-center p-6">
    <div className="study-card rounded-2xl p-8 text-center max-w-md">
      <h1 className="study-title text-2xl font-bold mb-3">Unable to load this page</h1>
      <p className="study-muted mb-6">The study resources are temporarily unavailable. Please try again.</p>
      <button className="study-button-primary px-5 py-3 rounded-xl" onClick={reset}>Try again</button>
      <Link className="study-link block mt-4" href="/">Return to PariksaHub</Link>
    </div>
  </div>;
}
